import clsx from "clsx";
import React, { FC } from "react";

interface Props {
  topGap?: boolean;
  label?: string;
  labelClasses?: string;
  icon?: any;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  disabled?: boolean;
  size?: "xs" | "md";
  id?: string;
}
const Button: FC<Props> = ({
  label,
  labelClasses,
  icon,
  topGap,
  type = "button",
  onClick,
  disabled = false,
  size = "md",
  id,
}) => {
  return (
    <>
      {topGap && <label className="tw-hidden sm:tw-block">&nbsp;</label>}
      <button
        id={id}
        type={type}
        disabled={disabled}
        onClick={onClick}
        className={clsx(
          "tw-w-full tw-block tw-text-center  tw-border tw-border-transparent tw-shadow-sm tw-text-md md:tw-text-sm tw-leading-4 tw-font-medium tw-rounded-md tw-text-white tw-bg-indigo-600 hover:tw-bg-indigo-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-indigo-500 disabled:tw-opacity-75 disabled:tw-cursor-not-allowed",
          "tw-py-4",
          size === "md" ? "md:tw-px-3 md:tw-py-2" : "tw-px-1 tw-py-1",          
        )}
      >
        {/* <icon className="" aria-hidden="true" /> */}
        {icon &&
          React.createElement(icon, { className: "tw-h-5 tw-w-5 tw-inline" })}

        {label && <span className={labelClasses}>{label}</span>}
      </button>
    </>
  );
};

export default Button;
